/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-16 15:50:06
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-22 11:02:56
 */
import moment from 'moment'
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnlyOne,
  DateTimeFormatSimpleOnly,
  DateTimeFormatSimpleText,
} from './datetime'

export function PrintBody(data: any) {
  const tenantName = data?.tenantName
  const dataList = data?.dataList
  let dataStr = ''

  for (let j = 0; j < dataList?.length; j++) {
    const periodValidity = dataList[j].periodValidity
      ? moment(dataList[j].periodValidity)?.format(DateTimeFormatSimple)
      : '-'
    const inStockTime = dataList[j].inStockTime
      ? moment(dataList[j].inStockTime)?.format(DateTimeFormatSimple)
      : '-'

    dataStr +=
      '<div style="display: table;width: 100%;justify-content: center;align-items: center;box-sizing: border-box;border-right: 1px solid #000000;border-left: 1px solid #000000;border-bottom: 1px solid #000000;text-align: center;">' +
      '<div style="width: 8%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].tenantName +
      '</div>' +
      '<div style="width: 8%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].tenantMaterialsName +
      '</div>' +
      '<div style="width:10%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].barCode +
      '</div>' +
      '<div style="width:10%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].spec +
      '</div>' +
      '<div style="width:8%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].doseCategory +
      '</div>' +
      '<div style="width:7%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].unit +
      '</div>' +
      '<div style="width:7%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].originName +
      '</div>' +
      '<div style="width:7%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].batchNo +
      '</div>' +
      '<div style="width:7%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      periodValidity +
      '</div>' +
      '<div style="width:7%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].counts +
      '</div>' +
      '<div style="width:7%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].shelfNo +
      '</div>' +
      '<div style="width:7%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      dataList[j].supplierName +
      '</div>' +
      '<div style="width:7%;display: table-cell;box-sizing: border-box;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">' +
      inStockTime +
      '</div>' +
      '</div>'
  }
  const contents =
    '<div style="page-break-after:always;page-break-inside:always;page-break-before:always;">' +
    '    <h3 style="text-align: center;margin-bottom: 0px">' +
    '近效期药品催销表' +
    '</h3>' +
    '<h4 style="text-align: center;margin-bottom: 5px" >' +
    tenantName +
    '</h4>' +
    '<div style="display: table;width: 100%;justify-content: center;align-items: center;box-sizing: border-box;border-right: 1px solid #000000;border-left: 1px solid #000000;border-top: 1px solid #000000;border-bottom: 1px solid #000000;text-align: center;">' +
    '<div style="width:8%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">门店名称' +
    '</div>' +
    '<div style="width:8%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">商品名' +
    '</div>' +
    '<div style="width:10%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">条形码' +
    '</div>' +
    '<div style="width:10%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">规格' +
    '</div>' +
    '<div style="width:8%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">剂型' +
    '</div>' +
    '<div style="width:7%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">单位' +
    '</div>' +
    '<div style="width:7%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">厂家' +
    '</div>' +
    '<div style="width:7%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">批号' +
    '</div>' +
    '<div style="width:7%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">有效期至' +
    '</div>' +
    '<div style="width:7%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">数量' +
    '</div>' +
    '<div style="width:7%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">货位' +
    '</div>' +
    '<div style="width:7%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">供货单位' +
    '</div>' +
    '<div style="width:7%;display: table-cell;box-sizing: border-box;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">入库日期' +
    ' </div>' +
    '</div>' +
    dataStr +
    '<div style="text-align: left;padding-bottom: 8px;font-weight: 600;font-size:13px;margin-top:10px">' +
    '</div>' +
    '</div>'
  return contents
}
